import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { useIsLoggedIn } from '~/context/common/UserContext';
import { syncAuthenticatedSession } from '~/utilities/datadog';

export default function useDataDogRUM() {
  const isLoggedIn = useIsLoggedIn();

  useSubsequentEffect(() => {
    if (!isLoggedIn) return;

    syncAuthenticatedSession();
  }, [isLoggedIn]);
}
